import "@/index.css";
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { I18nProvider } from '@/lib/i18n';
import {
  Navbar,
  Hero,
  Problem,
  Solution,
  Features,
  Pricing,
  Testimonials,
  Mobile,
  FAQ,
  CTA,
  Footer,
} from '@/components/landing';
import { Login, Register } from '@/components/auth';

const LandingPage = () => {
  return (
    <div className="min-h-screen" data-testid="landing-page">
      <Navbar />
      <main>
        <Hero />
        <Problem />
        <Solution />
        <Features />
        <Pricing />
        <Testimonials />
        <Mobile />
        <FAQ />
        <CTA />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <I18nProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
        </Routes>
      </BrowserRouter>
    </I18nProvider>
  );
}

export default App;
